{
  "menu.newRoute": "Uusi reitti",
  "menu.routePlanManager": "Tallennetut reitit",
  "menu.savedPlaces": "Tallennetut paikat",
  "menu.vesselConfigurator": "Aluksen asetukset",
  "menu.instructions": "Ohjeet",
  "menu.tour": "Opastettu kierros",
  "menu.information": "Tiedot",
  "information.tabMapLicenses": "Tietolähteet",
  "information.tabOpenSource": "Avoin lähdekoodi",
  "information.dataSources.osmTitle": "OpenStreetMap",
  "information.dataSources.osmText": "© <0>OpenStreetMap contributors</0>, lisenssi <1>ODbL 1.0</1>.",
  "information.dataSources.digitrafficTitle": "Digitraffic (Fintraffic)",
  "information.dataSources.digitrafficText": "Lähde: <0>Fintraffic / digitraffic.fi</0>, lisenssi <1>CC BY 4.0</1>.",
  "information.dataSources.fmiTitle": "Ilmatieteen laitos",
  "information.dataSources.fmiText": "Lähde: <0>Ilmatieteen laitoksen avoin data</0>, lisenssi <1>CC BY 4.0</1>.",
  "information.dataSources.traficomTitle": "Traficom",
  "information.dataSources.traficomText": "Lähde: <0>Traficom avoin data</0>, lisenssi <1>CC BY 4.0</1>.",
  "information.dataSources.vaylaTitle": "Väylävirasto",
  "information.dataSources.vaylaText": "Väylävirasto / latauspalvelu, lisenssi CC 4.0 BY.",
  "information.dataSources.traficomNauticalTitle": "Liikenne- ja viestintävirasto",
  "information.dataSources.traficomNauticalText": "Ei navigointikäyttöön. Ei täytä asianmukaisen merikartan vaatimuksia (avoimen datan merikartta).",
  "information.dataSources.traficomLicenseNotice": "©Traficom lisenssi nro TRAFICOM/108936/00.04.01.10/2026",
  "information.dataSources.traficomWarningText": "VAROITUS: Traficom ei ole tarkistanut tämän tuotteen tietoja, eikä\nse ota siten vastuuta tietojen oikeellisuudesta tai valmistuksen jäl-\nkeisistä muutoksista. Ei ole olemassa takuita siitä, että tämä tuote\nnoudattaa asianmukaisten navigointituotteiden käyttöä koskevia\nkansallisia tai kansainvälisiä säännöksiä.",
  "information.dataSources.mmlTopographicTitle": "Maanmittauslaitos",
  "information.dataSources.mmlTopographicText": "Maanmittauslaitoksen maastotietokanta.",
  "information.dataSources.mmlNamesTitle": "Maanmittauslaitos",
  "information.dataSources.mmlNamesText": "Maanmittauslaitoksen nimistö 01/2023.",
  "information.dataSources.smhiTitle": "SMHI",
  "information.dataSources.smhiText": "Lähde: SMHI.",
  "information.mapLicensesPlaceholder": "Kartta-aineistojen lisenssitiedot lisätään myöhemmin.",
  "information.openSourceGeneratedFromLockfile": "Avoimen lähdekoodin lisenssit generoidaan package-lock.json-tiedostosta.",
  "information.searchPlaceholder": "Hae paketteja…",
  "information.licenseUnknown": "Lisenssi tuntematon",
  "information.packageCount": "Paketteja: {{count}}",
  "menu.userAccount": "Käyttäjätili",
  "menu.harborManagement": "Satamatietojen hallinta",
  "menu.showHarborUpdateDates": "Näytä satamien päivityspäivät",
  "menu.logout": "Kirjaudu ulos",
  "menu.login": "Kirjaudu sisään",
  "menu.animate": "Animoi",
  "demo.play": "Toista",
  "demo.pause": "Tauko",
  "demo.speed": "Animaation nopeus",
  "demo.close": "Sulje animaatio",
  "demo.beta": "Beta",
  "demo.boat.label": "Vene",
  "demo.boat.scrollHint": "Pyyhkäise lisää",
  "demo.boat.sailboat": "Päivävene",
  "demo.boat.racingSailboat": "Kilpapurje",
  "demo.boat.cruisingSailboat": "Matkapurjevene",
  "demo.boat.smallMotorboat": "Avovene",
  "demo.boat.largeMotorboat": "Hytillinen",
  "demo.boat.speedboat": "Pikavene",
  "demo.boat.rowingBoat": "Soutuvene",
  "demo.boat.kayak": "Kajakki",
  "demo.boat.submarine": "Sukellusvene",
  "demo.boat.premiumDialog.title": "Sailmate Premium",
  "demo.boat.premiumDialog.message": "„{{boat}}” edellyttää Sailmate Premium -tilausta. Tilaa Premium avataksesi kaikki venemallit Animoi-tilaan ja videovientiin.",
  "demo.boat.premiumDialog.hint": "Premiumiin kuuluvat myös merikartat, sää, AIS ja edistyneet navigointityökalut.",
  "demo.boat.premiumDialog.subscribe": "Tilaa",
  "demo.export.button": "Vie video",
  "demo.export.title": "Vie reittivideo",
  "demo.export.description": "Renderöi koko reitin {{seconds}} s:ssa Sailmate-logolla. Valmis someen.",
  "demo.export.duration": "Videon pituus",
  "demo.export.durationOption": "{{seconds}} s",
  "demo.export.durationRecommended": "Paras",
  "demo.export.durationHint": "Tälle {{distance}} reitille {{seconds}} s näyttää sulavimmalta",
  "demo.export.durationCalmHint": "Haluatko rauhallisemman tahdin? Kokeile {{seconds}} s",
  "demo.export.durationTooShort": "Liian lyhyt tälle reitille — liike näyttäisi kiireiseltä",
  "demo.export.durationRushedWarning": "Tämä pituus voi näyttää kiireiseltä; pidempi video on sulavampi",
  "demo.export.aspect": "Kuvasuhde",
  "demo.export.aspectHintLandscape": "16:9 — YouTube, X, vaaka",
  "demo.export.aspectHintVertical": "9:16 — Reels, TikTok, Stories",
  "demo.export.scene": "Kamera",
  "demo.export.scene.cinematic": "Elokuvallinen",
  "demo.export.scene.follow": "Seuraa",
  "demo.export.scene.cinematicHint": "Kamera loitontaa ja kiertää tasaisesti. Vene pysyy kuvassa ja pienenee loitontuessa",
  "demo.export.scene.followHint": "Takaa seuraava kamera veneen perässä",
  "demo.export.titleText": "Otsikko",
  "demo.export.titleSource.none": "Ei",
  "demo.export.titleSource.route": "Reitin nimi",
  "demo.export.titleSource.custom": "Oma teksti",
  "demo.export.titleSource.noneHint": "Videossa ei näytetä otsikkoa",
  "demo.export.titleSource.routeHint": "“{{name}}” häivytetään muutaman sekunnin kuluttua",
  "demo.export.titleSource.routeMissing": "Nimeä reitti reittisuunnitelmassa näyttääksesi sen",
  "demo.export.titleCustomPlaceholder": "Otsikko videossa",
  "demo.export.titleMaxLength": "{{count}} / {{max}}",
  "demo.export.titleFont": "Kirjasin",
  "demo.export.titleFont.finlandica": "Finlandica",
  "demo.export.titleFont.outfit": "Outfit",
  "demo.export.titleFont.libreBaskerville": "Baskerville",
  "demo.export.titleBackground": "Tausta",
  "demo.export.titleBackground.glow": "Hehku",
  "demo.export.titleBackground.dim": "Himmeä",
  "demo.export.titleBackground.highlight": "Palkit",
  "demo.export.titleBackground.light": "Vaalea",
  "demo.export.showElapsedDistance": "Näytä kuljettu matka",
  "demo.export.showElapsedDistanceHint": "Näytetään videon alareunassa",
  "demo.export.distanceUnit": "Matkayksikkö",
  "demo.export.distanceUnitNm": "nm",
  "demo.export.distanceUnitKm": "km",
  "demo.export.cancel": "Peruuta",
  "demo.export.create": "Luo video",
  "demo.export.rendering": "Luodaan videota… {{percent}} %",
  "demo.export.renderingHint": "Pidä tämä välilehti auki, kunnes lataus alkaa.",
  "demo.export.tipLabel": "Odottelun iloksi",
  "demo.export.tips.0": "Vedenkorkeus nostaa kaikki veneet — paitsi sen, joka on vielä trailerin päällä.",
  "demo.export.tips.1": "Punainen vasemmalle satamaan — ellei tulla väärästä suunnasta. Silloin luotetaan merikorttiin, ei muistisääntöön.",
  "demo.export.tips.2": "Tuuli nousee aina viisi minuuttia sen jälkeen, kun fokka on jo kääritty.",
  "demo.export.tips.3": "GPS on tarkka. Juuri löytämäsi kivi on vielä tarkempi.",
  "demo.export.tips.4": "Jos kahvi pysyy mukissa, et purjehdi vielä tarpeeksi kovaa.",
  "demo.export.tips.5": "Kiinnitysköysi ei ole koskaan liian pitkä — ennen kuin se on potkurissa.",
  "demo.export.tips.6": "Sääennuste on ehdotus. Sadekuuro on palaute.",
  "demo.export.tips.7": "Lepuuttajia ei ole koskaan liikaa. Silminnäkijöitä on liian harvoin.",
  "demo.export.tips.8": "Lyhin reitti on suora viiva. Turvallisin kulkee väylää pitkin.",
  "demo.export.tips.9": "Jos kaikki menee suunnitelman mukaan, tarkista vielä vedenkorkeus.",
  "demo.export.tips.10": "Yksi käsi veneelle, yksi itselle — ja silti jotenkin kolme puhelimelle.",
  "demo.export.tips.11": "Ankkuri puree parhaiten juuri sen jälkeen, kun olet jo ilmoittanut sen pitävän.",
  "demo.export.tips.12": "Hyvää keliä ja myötätuulta… lounaaseen asti, jolloin molemmat kääntyvät kiusallaan.",
  "demo.export.tips.13": "Kuiva pilssi on ohimenevä olotila, ei luonteenpiirre.",
  "demo.export.tips.14": "Älä huuda laiturissa „mä hoidan!”, ellet oikeasti nauti teatterista.",
  "demo.export.tips.15": "Reivaa ajoissa — ja selitä silti myöhemmin, miksi et reivannut aiemmin.",
  "demo.export.tips.16": "Plotteri on itsevarma. Kaikuluotain on rehellinen.",
  "demo.export.tips.17": "Pelastusliivin ehtii aina pukea — kunnes yhtäkkiä ei ehdi.",
  "demo.export.tips.18": "Purjetta osaa kantaa kuka tahansa. Reivaaminen erottaa oikean veneilijän.",
  "demo.export.tips.19": "Paras laituripaikka on se, josta pääsee lähtemään ilman yleisöä.",
  "demo.export.tips.20": "Springiköydet ovat olemassa siksi, ettei ylpeys kohtaa naapurivenettä.",
  "demo.export.tips.21": "Jos pohja näkyy, sinulla on joko tuuria — tai joudut selittämään jotain.",
  "demo.export.tips.22": "Sääsovellus päivittyy. Pilvet eivät odota päivitystä.",
  "demo.export.tips.23": "Jätä vene siistiksi seuraavalle vahdille — vaikka seuraava vahti olisit sinä.",
  "demo.export.success": "Video ladattu",
  "demo.export.error": "Videon luonti epäonnistui",
  "demo.export.unsupported": "Videon vienti ei ole tuettu tässä selaimessa",
  "menu.chartSettings": "Kartta-asetukset",
  "menu.chartSettingsSubtitle": "Yksiköt, S57-symbolit ja paletti",
  "toolbar.routingMode": "Reitin muokkaustila",
  "toolbar.routingModeOff": "Reitin muokkaus pois",
  "toolbar.routingModeAuto": "Väyläreititys",
  "toolbar.routingModeManual": "Viivareititys",
  "toolbar.reachArea": "Saavutettava alue",
  "toolbar.showReachArea": "Näytä saavutettava alue",
  "toolbar.hideReachArea": "Piilota saavutettava alue",
  "toolbar.setReachArea": "Aseta saavutettava alue",
  "toolbar.addSailingPoint": "Lisää veneilykohde",
  "toolbar.search": "Haku",
  "mapControls.zoomIn": "Lähennä",
  "mapControls.zoomOut": "Loitonna",
  "mapControls.resetNorth": "Palauta pohjoinen",
  "mapControls.forecast": "Sääennuste",
  "placeSearch.placeholder": "Hae paikkoja…",
  "placeSearch.placesPlaceholder": "Hae paikkoja…",
  "placeSearch.harborsPlaceholder": "Hae satamia…",
  "placeSearch.inputLabel": "Hae paikkoja",
  "placeSearch.tabPlaces": "Paikat",
  "placeSearch.tabHarbors": "Satamat",
  "placeSearch.emptyHint": "Aloita kirjoittamalla paikan nimi.",
  "placeSearch.loading": "Ladataan paikkoja…",
  "placeSearch.harborsLoading": "Ladataan satamia…",
  "placeSearch.unavailable": "Paikkahaku ei käytettävissä",
  "placeSearch.harborsUnavailable": "Satamahaku ei käytettävissä",
  "placeSearch.retry": "Yritä uudelleen",
  "placeSearch.harborsEmptyHint": "Aloita kirjoittamalla sataman nimi.",
  "placeSearch.noResults": "Ei tuloksia",
  "placeSearch.clear": "Tyhjennä",
  "placeSearch.close": "Sulje",
  "toolbar.layers": "Karttatasot",
  "toolbar.menu": "Valikko",
  "chartSettings.title": "Kartta-asetukset",
  "chartSettings.symbolSize": "Symbolien koko",
  "chartSettings.symbolSizeSmall": "Pieni",
  "chartSettings.symbolSizeMedium": "Keski",
  "chartSettings.symbolSizeLarge": "Suuri",
  "chartSettings.symbolStyle": "Symbolityyli",
  "chartSettings.symbolStyleOfficial": "Virallinen",
  "chartSettings.symbolStyleColourful": "Värillinen",
  "chartSettings.palette": "Paletti",
  "chartSettings.paletteNormal": "Normaali",
  "chartSettings.paletteNight": "Yötila",
  "chartSettings.paletteHighContrast": "Suuri kontrasti",
  "chartSettings.units": "Yksiköt",
  "chartSettings.unitsNautical": "kn, nm",
  "chartSettings.unitsSi": "km/h, km",
  "chartSettings.s57Section": "S57-kartta",
  "chartSettings.s57SectionDescription": "Nämä asetukset vaikuttavat vain S57-karttoihin.",
  "chartSettings.simplifiedS57": "Yksinkertaistettu kartta",
  "chartSettings.simplifiedS57Description": "Piilota syvyysluvut, sektoriloistot, syvyyskäyrät, rajoitusalueet, kaapelit ja putkilinjat nopeampaa renderöintiä varten.",
  "inactivity.title": "Päivitys keskeytetty",
  "inactivity.body": "AIS- ja säähavaintojen automaattinen päivitys on keskeytetty toimettomuuden vuoksi. Jatka, niin päivitys käynnistyy uudelleen.",
  "inactivity.continue": "Jatka päivitystä",
  "layers.title": "Karttatasot",
  "layers.sectionCharts": "Kartat",
  "layers.sectionOverlays": "Lisätasot",
  "layers.sectionSummaryNone": "Ei päällä",
  "layers.sectionSummaryMore": "+{{count}}",
  "layers.sectionPois": "Paikat ja POI:t",
  "layers.sectionRoutes": "Reitit",
  "layers.sectionRestrictions": "Rajoitusalueet",
  "layers.sectionLiveData": "Ajantasainen data",
  "layers.weather": "Säähavainnot",
  "layers.harbor": "Satamat",
  "layers.recreationSites": "Retkeilykohteet",
  "layers.septic": "Septityhjennysasemat",
  "layers.ais": "AIS-kohteet",
  "layers.ice": "Jäätilanne",
  "layers.navWarnings": "Merivaroitukset",
  "navWarning.number": "Varoitus {{number}}",
  "navWarning.published": "Julkaistu {{time}}",
  "navWarning.dataAttribution": "Data: Traficomin merivaroitukset (avoin data)",
  "information.dataSources.traficomNavWarningsText": "Sisältää merivaroitukset Traficomin avoimen WFS-palvelun kautta.",
  "forecast.attr.wind": "Tuuli",
  "forecast.attr.wind_gust": "Puuska",
  "forecast.attr.temperature": "Lämpötila",
  "forecast.attr.rainfall": "Sade",
  "forecast.attr.cloud_cover": "Pilvisyys",
  "forecast.isobars": "Ilmanpaine",
  "forecast.play": "Toista",
  "forecast.pause": "Tauko",
  "forecast.prev": "Edellinen tunti",
  "forecast.next": "Seuraava tunti",
  "forecast.loading": "Ladataan ennustetta…",
  "forecast.modelRun": "Malliajo {{time}}",
  "forecast.source": "Ilmatieteenlaitos Harmonie",
  "forecast.point.title": "Ennuste tässä",
  "forecast.point.close": "Sulje",
  "forecast.point.noData": "Ei dataa",
  "forecast.premiumTimeline": "Myöhemmät tunnit vaativat Premiumin",
  "layers.networkTiles": "Mobiiliverkon laatu",
  "layers.networkTilesTech": "Verkko",
  "layers.networkTilesTech4g": "4G",
  "layers.networkTilesTech5g": "5G",
  "layers.networkTilesOperator": "Operaattori",
  "layers.networkTilesOperatorElisa": "Elisa",
  "layers.networkTilesOperatorDna": "DNA",
  "layers.networkTilesOperatorTelia": "Telia",
  "layers.networkTilesMetric": "Mittari",
  "layers.networkTilesMetricDownload": "Latausnopeus",
  "layers.networkTilesMetricUpload": "Lähetysnopeus",
  "layers.networkTilesMetricLatency": "Viive",
  "layers.networkTilesMetricRsrp": "RSRP-signaali",
  "layers.networkTilesLegendTitle": "Verkon laadun selite",
  "layers.networkTilesLegendLoading": "Ladataan verkkotiiliä",
  "layers.networkTilesBandVeryBad": "Erittäin heikko",
  "layers.networkTilesBandBad": "Heikko",
  "layers.networkTilesBandFair": "Kohtalainen",
  "layers.networkTilesBandGood": "Hyvä",
  "layers.networkTilesBandExcellent": "Erinomainen",
  "layers.raster2025": "Merikortti (rasteri)",
  "layers.rasterSpecial": "Erikoiskartat",
  "layers.avoinMerikartta": "Avoin merikartta (vektori)",
  "layers.maastokartta": "Maastokartta",
  "layers.combined": "Meri- ja maastokartta (vektori)",
  "layers.s57": "Merikartta (S57, vektori)",
  "layers.scoutRoutes": "Partiolaisten reitit",
  "layers.scoutRouting": "Automaattireititys partioreiteillä",
  "layers.savedPlaces": "Tallennetut paikat",
  "layers.restriction01SpeedLimit": "Nopeusrajoitus",
  "layers.restriction02NoWake": "Aallokon aiheuttamisen kielto",
  "layers.restriction03NoWindsurfing": "Purjelautailukielto",
  "layers.restriction04NoJetSki": "Vesiskootterilla ajo kielletty",
  "layers.restriction05NoMotorPower": "Aluksen kulku moottorivoimaa käyttäen kielletty",
  "layers.restriction06NoAnchoring": "Ankkurin käyttökielto",
  "layers.comingSoon": "Tulossa",
  "layers.scoutSubscription": "Partio-tilaus",
  "layers.premium": "Premium",
  "layers.beta": "Beta",
  "layers.premiumBeta": "Premium beta",
  "s57.infoDialogTitle": "S57-vektorikartat",
  "s57.infoDialogParagraph1": "Kiitos, että tutustut Sailmaten uuteen vektorikarttaan. Kehitämme siitä parhaan mahdollisen kartan kotivesillemme — palautteesi on meille tärkeää.",
  "s57.infoDialogParagraph2": "Kartta perustuu Traficomin viralliseen S-57-dataan. Olemme säätäneet esitystapaa suomalaisten veneilijöiden tarpeisiin; kerro meille, miltä kartta näyttää ja miten sisältö toimii eri zoom-tasoilla.",
  "s57.infoDialogMobileSpring": "Tulossa mobiilisovelluksiin keväällä.",
  "s57.betaWarning": "S57-kartat ovat beta-testauksessa",
  "s57.feedbackTitle": "Vektorikarttapalaute",
  "s57.feedbackSendButton": "Lähetä palaute",
  "s57.feedbackButton": "Palaute",
  "s57.feedbackMailtoHint": "Voit avata palautteen Gmailissa selaimessa tai omassa sähköpostisovelluksessasi. Jos mikään ei avaudu, kopioi osoite ja liitä se sähköpostiin käsin.",
  "s57.feedbackOpenInGmail": "Avaa Gmailissa",
  "s57.feedbackOpenInMailApp": "Sähköpostisovellus",
  "s57.feedbackCopyEmail": "Kopioi osoite",
  "s57.feedbackCopyEmailSuccess": "Osoite kopioitu — voit liittää sen sähköpostiin.",
  "s57.feedbackCopyEmailFailed": "Kopiointi epäonnistui — valitse osoite yllä käsin.",
  "reachableArea.title": "Saavutettava alue",
  "reachableArea.distanceNm": "Etäisyysbudjetti",
  "reachableArea.nm": "nm",
  "reachableArea.km": "km",
  "reachableArea.hint": "Näyttää väylät, joille pääsee viimeisestä pisteestä paikallisella väyläreitityksellä.",
  "routePlan.downloadGPX": "Lataa suunnitelma GPX-muodossa",
  "routePlan.groupLegs": "Ryhmitä valitut legit",
  "routePlan.ungroupLegs": "Pura legien ryhmitys",
  "routePlan.ungroupLegsAria": "Pura ryhmitys",
  "routePlan.title": "Reittisuunnitelma",
  "routePlan.nameLabel": "Reitin nimi",
  "routePlan.namePlaceholder": "Nimetön reitti",
  "routePlan.totalDistance": "Kokonaismatka",
  "routePlan.eta": "ETA",
  "routePlan.waypoints": "Pisteet",
  "routePlan.waypoint": "Piste",
  "routePlan.start": "Alku",
  "routePlan.finish": "Loppu",
  "routePlan.emptyTitle": "Ei pisteitä vielä",
  "routePlan.emptyHintOff": "Valitse reititystila työkalupalkista aloittaaksesi suunnittelun.",
  "routePlan.emptyHintOn": "Pidä karttaa painettuna lisätäksesi pisteitä. Napauta riviä poistaaksesi, tai poista kartalta.",
  "routePlan.clear": "Tyhjennä",
  "routePlan.clearConfirmTitle": "Tyhjennetäänkö reitti?",
  "routePlan.clearConfirmBody": "Sinulla on muutoksia, joita ei ole tallennettu pilveen. Tyhjentäminen hävittää ne.",
  "routePlan.calculating": "Lasketaan reittiä…",
  "routePlan.savedLocally": "Tallennettu paikallisesti",
  "routePlan.untitledRoute": "Nimetön reitti",
  "routePlan.editVesselSettings": "Muokkaa",
  "routePlan.cloudTitle": "Pilvisynkronointi",
  "routePlan.cloudSubtitle": "Tallenna reitti pilveen ja käytä sitä muilla laitteilla.",
  "routePlan.cloudNameLabel": "Reitin nimi",
  "routePlan.cloudNameHelper": "Nimi tallennetaan pilveen, kun painat Tallenna.",
  "routePlan.cloudSave": "Tallenna pilveen",
  "routePlan.cloudSaveChanges": "Tallenna muutokset",
  "routePlan.cloudRenameHint": "Nimen vaihto vaatii tallennuksen",
  "routePlan.cloudNotSaved": "Ei tallennettu",
  "routePlan.cloudSynced": "Synkronoitu",
  "routePlan.cloudSyncing": "Synkronoidaan…",
  "routePlan.cloudSyncError": "Synkronointi epäonnistui",
  "routePlan.cloudPending": "Muutoksia odottaa",
  "routePlan.cloudAutoSync": "Automaattitallennus käytössä",
  "routePlan.cloudAutoSaveLabel": "Automaattitallennus",
  "routePlan.cloudSaveManually": "Tallenna manuaalisesti kun olet valmis.",
  "routePlan.cloudLastSynced": "Synkronoitu viimeksi {{time}}",
  "routePlan.cloudLoginTitle": "Kirjaudu sisään tallentaaksesi reitit",
  "routePlan.cloudLoginBody": "Luo tili tallentaaksesi reitit pilveen ja synkronoidaksesi ne.",
  "routePlan.cloudLoginCta": "Kirjaudu sisään",
  "routePlan.cloudPremiumTitle": "Premium vaaditaan",
  "routePlan.cloudPremiumBody": "Pilvitallennus on Premium-ominaisuus.",
  "routePlan.cloudPremiumCta": "Päivitä",
  "routePlan.cloudCheckingAccount": "Tarkistetaan tiliä…",
  "routePlan.cloudSaveError": "Reitin tallennus epäonnistui.",
  "routePlan.cloudAuthError": "Istuntotunnus puuttuu.",
  "routePlan.cloudProfileMissing": "Profiilia ei ole saatavilla.",
  "routePlan.cloudNoWaypoints": "Lisää vähintään yksi piste tallentaaksesi.",
  "routePlan.cloudLoginRequired": "Kirjaudu sisään tallentaaksesi tämän reitin.",
  "routePlan.cloudPremiumRequired": "Premium-tilaus vaaditaan.",
  "routePlan.routingAutoFailed": "Reittiä ei löytynyt.",
  "routePlan.addWaypointFailed": "Pisteen lisääminen epäonnistui.",
  "routePlan.insertWaypointFailed": "Pisteen lisääminen väliin epäonnistui.",
  "routePlan.removeWaypointFailed": "Pisteen poistaminen epäonnistui.",
  "routePlan.relocateWaypointFailed": "Pisteen siirtäminen epäonnistui.",
  "routePlan.loadRouteFailed": "Reitin lataaminen epäonnistui.",
  "routePlan.editingEnabled": "Reitin muokkaus käytössä",
  "routePlan.waypointLimitTitle": "Kirjaudu sisään pidempiä reittejä varten",
  "routePlan.waypointLimitMessage": "Voit lisätä enintään kolme pistettä ilman tiliä. Kirjaudu sisään avataksesi pidemmän reittisuunnittelun ja synkronoinnin.",
  "routePlan.waypointLimitHint": "Se vie vain hetken — lähetämme kertakoodin sähköpostiisi.",
  "routePlan.waypointLimitCta": "Kirjaudu sisään",
  "routePlan.summary": "Reittiyhteenveto",
  "routePlan.etaLabelShort": "ETA {{eta}}",
  "routePlan.trackedWaypointChip": "Jälki",
  "routePlan.waypointModeAuto": "Väylä",
  "routePlan.waypointModeManual": "Viiva",
  "routePlan.deleteWaypointTitle": "Poista piste?",
  "routePlan.deleteWaypointMessage": "Haluatko varmasti poistaa \"{{waypoint}}\" (piste {{index}})? Tätä toimintoa ei voi perua.",
  "routePlan.delete": "Poista",
  "routePlan.cancel": "Peruuta",
  "routes.title": "Omat reitit",
  "routes.subtitle": "Hallitse ja lataa tallennettuja reittejä.",
  "routes.currentRoute": "Nykyinen reitti",
  "routes.selectedRoute": "Valittu reitti",
  "routes.saveNew": "Tallenna uutena",
  "routes.saveNewDialogTitle": "Uuden reitin nimi",
  "routes.overwrite": "Ylikirjoita valittu",
  "routes.loadToPlanner": "Avaa",
  "routes.delete": "Poista",
  "routes.cancel": "Peruuta",
  "routes.refresh": "Päivitä",
  "routes.loading": "Ladataan reittejä…",
  "routes.ready": "Valmis",
  "routes.calculating": "Lasketaan",
  "routes.count": "{{count}} reittiä",
  "routes.waypointsCount": "{{count}} pistettä",
  "routes.updatedAt": "Päivitetty {{date}}",
  "routes.searchPlaceholder": "Hae reittejä",
  "routes.emptyTitle": "Ei tallennettuja reittejä",
  "routes.emptyHint": "Tallenna nykyinen reitti, niin se näkyy täällä.",
  "routes.selectTitle": "Valitse reitti",
  "routes.selectHint": "Valitse reitti nähdäksesi tiedot ja toiminnot.",
  "routes.loginRequired": "Kirjaudu sisään nähdäksesi tallennetut reitit.",
  "routes.login": "Kirjaudu sisään",
  "routes.sharedHint": "Jaetun reitin koodi",
  "routes.deleteConfirmTitle": "Poista reitti?",
  "routes.deleteConfirmMessage": "Poistetaanko \"{{name}}\"? Tätä ei voi perua.",
  "routes.errorMissingToken": "Pääsytunnus puuttuu.",
  "routes.errorMissingProfile": "Käyttäjäprofiilin tunnus puuttuu.",
  "routes.errorMissingSelection": "Valitse ensin reitti.",
  "routes.errorSubscriptionRequired": "Voimassa oleva tilaus vaaditaan reittien tallentamiseen ja hallintaan.",
  "routes.errorGeneric": "Jotain meni pieleen.",
  "routes.untitledRoutePlaceholder": "Nimetön reitti",
  "routes.importExport.exportCurrent": "Vie nykyinen GPX",
  "routes.importExport.exportSelected": "Vie GPX-muodossa",
  "routes.importExport.exportAll": "Vie kaikki GPX",
  "routes.importExport.importRoute": "Tuo reitti GPX",
  "routes.importExport.exportedSingle": "Reitti vietiin GPX-tiedostona.",
  "routes.importExport.exportedAll": "{{count}} reittiä vietiin GPX-tiedostona.",
  "routes.importExport.importedRoute": "Reitti tuotiin suunnitelmaan.",
  "routes.importExport.invalidRouteGpx": "GPX-tiedostosta ei löytynyt kelvollisia reittipisteitä.",
  "routes.importExport.invalidXml": "Virheellinen GPX-tiedosto.",
  "routes.importExport.importFailed": "Reitin GPX-tuonti epäonnistui.",
  "routes.importExport.noSavedRoutes": "Ei tallennettuja reittejä vietäväksi.",
  "routes.importExport.noCurrentRoute": "Nykyisessä reitissä ei ole vietäviä pisteitä.",
  "places.title": "Omat paikat",
  "places.subtitle": "Hallitse tallennettuja paikkoja.",
  "places.selectedPlace": "Valittu paikka",
  "places.nameLabel": "Nimi",
  "places.latitude": "Leveysaste",
  "places.longitude": "Pituusaste",
  "places.update": "Tallenna muutokset",
  "places.delete": "Poista",
  "places.cancel": "Peruuta",
  "places.refresh": "Päivitä",
  "places.loading": "Ladataan paikkoja…",
  "places.count": "{{count}} paikkaa",
  "places.updatedAt": "Päivitetty {{date}}",
  "places.searchPlaceholder": "Hae paikkoja",
  "places.emptyTitle": "Ei tallennettuja paikkoja",
  "places.emptyHint": "Tallennetut paikat näkyvät täällä.",
  "places.selectTitle": "Valitse paikka",
  "places.selectHint": "Valitse paikka nähdäksesi tiedot ja toiminnot.",
  "places.loginRequired": "Kirjaudu sisään nähdäksesi tallennetut paikat.",
  "places.login": "Kirjaudu sisään",
  "places.deleteConfirmTitle": "Poista paikka?",
  "places.deleteConfirmMessage": "Poistetaanko \"{{name}}\"? Tätä ei voi perua.",
  "places.errorMissingToken": "Pääsytunnus puuttuu.",
  "places.errorMissingProfile": "Käyttäjäprofiilin tunnus puuttuu.",
  "places.errorMissingSelection": "Valitse ensin paikka.",
  "places.errorInvalidName": "Anna nimi.",
  "places.errorInvalidCoordinates": "Anna kelvolliset koordinaatit.",
  "places.errorSubscriptionRequired": "Voimassa oleva tilaus vaaditaan tallennettujen paikkojen hallintaan.",
  "places.errorGeneric": "Jotain meni pieleen.",
  "places.untitledPlacePlaceholder": "Nimetön paikka",
  "places.importExport.exportSelected": "Vie GPX-muodossa",
  "places.importExport.exportAll": "Vie kaikki GPX",
  "places.importExport.importPlace": "Tuo paikka GPX",
  "places.importExport.exportedSingle": "Paikka vietiin GPX-tiedostona.",
  "places.importExport.exportedAll": "{{count}} paikkaa vietiin GPX-tiedostona.",
  "places.importExport.importedPlace": "Paikka tuotiin.",
  "places.importExport.invalidPlaceGpx": "GPX-tiedostosta ei löytynyt kelvollista reittipistettä.",
  "places.importExport.invalidXml": "Virheellinen GPX-tiedosto.",
  "places.importExport.importFailed": "Paikan GPX-tuonti epäonnistui.",
  "places.importExport.noSavedPlaces": "Ei tallennettuja paikkoja vietäväksi.",
  "places.createNewPlace": "Luo uusi paikka",
  "places.namePlaceholder": "Anna paikan nimi",
  "places.save": "Tallenna",
  "places.centerOnMap": "Keskitä kartta tähän",
  "places.coordinates": "Koordinaatit",
  "places.unnamedPlace": "Nimetön paikka",
  "places.subscriptionRequiredTitle": "Tilaus vaaditaan",
  "places.subscriptionRequiredMessage": "Paikkojen tallentaminen vaatii voimassa olevan tilauksen. Tilaa palvelu käyttääksesi tämän ominaisuuden ja hallitaksesi suosikkipaikkojasi.",
  "places.subscriptionRequiredHint": "Tilauksella voit tallentaa rajoittamattoman määrän paikkoja, käyttää edistyneitä reititysominaisuuksia ja paljon muuta.",
  "places.viewSubscription": "Näytä tilaus",
  "places.loginRequiredTitle": "Kirjaudu sisään tallentaaksesi paikkoja",
  "places.loginRequiredMessage": "Luo tili tallentaaksesi paikkoja ja pitääksesi ne synkronoituna laitteiden välillä.",
  "places.loginRequiredHint": "Tilin luominen on helppoa ja nopeaa, tarvitset vain sähköpostiosoitteen, johon lähetämme varmistuskoodin",
  "places.loginRequiredCta": "Kirjaudu sisään",
  "places.categoryLabel": "Kategoria",
  "places.descriptionLabel": "Kuvaus",
  "places.descriptionPlaceholder": "Valinnainen kuvaus",
  "places.filterCategories": "Kategoriat",
  "places.filterAllCategories": "Kaikki kategoriat",
  "places.sortDistance": "Etäisyys",
  "places.saveAndShowTitle": "Tallenna ja näytä kuvakkeet?",
  "places.saveAndShowMessage": "Omat paikat -taso on piilotettu. Tallennetaanko paikka ja näytetäänkö kuvakkeet kartalla?",
  "places.saveAndShow": "Tallenna ja näytä",
  "places.saveWithoutShowing": "Tallenna ilman näyttämistä",
  "places.categories.FAVORITE": "Suosikki",
  "places.categories.FISH": "Kalapaikka",
  "places.categories.COTTAGE": "Mökki",
  "places.categories.WARNING": "Varoitus",
  "places.categories.INFO": "Info",
  "places.categories.SIGHT": "Nähtävyys",
  "places.categories.ANCHOR": "Ankkuripaikka",
  "places.photos.title": "Kuvat",
  "places.photos.add": "Lisää",
  "places.photos.remove": "Poista kuva",
  "places.photos.onlineOnly": "Kuvia voi hallita vain online-tilassa.",
  "places.photos.maxReached": "Voit lisätä enintään {{count}} kuvaa.",
  "places.photos.invalidType": "Valitse kuvatiedosto.",
  "places.photos.uploadFailed": "Kuvan lataus epäonnistui.",
  "places.photos.deleteFailed": "Kuvan poisto epäonnistui.",
  "places.photos.viewFullscreen": "Näytä kuva koko ruudulla",
  "places.photos.previous": "Edellinen kuva",
  "places.photos.next": "Seuraava kuva",
  "common.cancel": "Peruuta",
  "common.done": "Valmis",
  "common.edit": "Muokkaa",
  "common.sortBy": "Lajittele",
  "common.sortOrder": "Järjestys",
  "common.sortAttributeUpdated": "Päivitetty",
  "common.sortAttributeCreated": "Luotu",
  "common.sortAttributeName": "Nimi",
  "common.sortAsc": "Nouseva",
  "common.sortDesc": "Laskeva",
  "drawer.openRoutePlan": "Avaa reittisuunnitelma",
  "drawer.closeRoutePlan": "Sulje reittisuunnitelma",
  "drawer.showRoutePlan": "Näytä reittisuunnitelma",
  "drawer.hideRoutePlan": "Piilota reittisuunnitelma",
  "common.loginRequired": "Kirjautuminen vaaditaan",
  "common.checkingAccount": "Tarkistetaan tiliä…",
  "common.subscriptionRequired": "Tilaus vaaditaan",
  "common.close": "Sulje",
  "common.notNow": "Ei nyt",
  "common.language": "Kieli",
  "recreation.titleFallback": "Retkeilykohde",
  "recreation.loading": "Ladataan…",
  "recreation.loadError": "Kohteen tietoja ei voitu ladata.",
  "recreation.description": "Kuvaus",
  "recreation.showMore": "Näytä lisää",
  "recreation.showLess": "Näytä vähemmän",
  "recreation.highlights": "Kohokohdat",
  "recreation.arrival": "Saapuminen",
  "recreation.accessibility": "Esteettömyys",
  "recreation.rules": "Säännöt",
  "recreation.contacts": "Yhteystiedot",
  "recreation.details": "Tiedot",
  "recreation.category": "Kategoria",
  "recreation.geometry": "Geometria",
  "recreation.owner": "Omistaja",
  "recreation.admin": "Ylläpitäjä",
  "recreation.lastModified": "Päivitetty",
  "recreation.openInLipas": "Avaa Lipas-sivulla",
  "recreation.dataAsOf": "Aineisto {{date}}",
  "recreation.imageCopyright": "© {{copyright}}",
  "recreation.imageAltFallback": "Retkeilykohteen kuva",
  "recreation.previousImage": "Edellinen kuva",
  "recreation.nextImage": "Seuraava kuva",
  "recreation.imageIndex": "{{current}} / {{total}}",
  "harbor.titleFallback": "Satama",
  "harbor.portNumber": "Satama",
  "harbor.depth": "Syvyys",
  "harbor.places": "Paikkoja",
  "harbor.mooring": "Kiinnittyminen",
  "harbor.official": "Virallinen",
  "harbor.unofficial": "Epävirallinen",
  "harbor.amenitiesTitle": "Palvelut",
  "harbor.openChart": "Avaa lähestymiskartta",
  "harbor.scoutPort": "Partiosatama",
  "harbor.spv": "SPV",
  "harbor.overview": "Yleiskuva",
  "harbor.portInfo": "Satamatiedot",
  "harbor.servicesTitle": "Palvelut",
  "harbor.relatedContent": "Aiheeseen liittyvä sisältö",
  "harbor.relatedArticles": "Aiheeseen liittyvät artikkelit",
  "harbor.linksTitle": "Linkit",
  "harbor.scoutTip": "Sisältää partiolaisten tietoja!",
  "harbor.openContent": "Avaa sisältö",
  "harbor.openArticle": "Avaa artikkeli",
  "harbor.openScoutChart": "Avaa partion satamakartta",
  "harbor.openAerial": "Avaa ilmakuvan",
  "harbor.openSeptit": "Avaa septit.net",
  "harbor.amenities.toilet": "WC",
  "harbor.amenities.drinkingWater": "Juomavesi",
  "harbor.amenities.sauna": "Sauna",
  "harbor.amenities.fuel": "Polttoaine",
  "harbor.amenities.restaurant": "Ravintola",
  "harbor.amenities.kiosk": "Kioski",
  "harbor.amenities.recycling": "Kierrätys",
  "harbor.services.wc": "WC",
  "harbor.services.shower": "Suihku",
  "harbor.services.drinking_water": "Juomavesi",
  "harbor.services.electricity": "Sähkö",
  "harbor.services.harbour": "Satama",
  "harbor.services.fuel": "Polttoaine",
  "harbor.services.boat_ramp": "Veneenlasku",
  "harbor.services.septic_tank": "Septitankki",
  "harbor.services.wash_house": "Pyykkitupa",
  "harbor.services.engine": "Moottorihuolto",
  "harbor.services.restaurant": "Ravintola",
  "harbor.services.cafe": "Kahvila",
  "harbor.services.kiosk": "Kioski",
  "harbor.services.foodkiosk": "Ruokakioski",
  "harbor.services.sauna": "Sauna",
  "harbor.services.beach": "Uimaranta",
  "harbor.services.playground": "Leikkipaikka",
  "harbor.services.grill": "Grilli",
  "harbor.services.naturetrail": "Luontopolku",
  "harbor.services.sigthseeing": "Nähtävyydet",
  "harbor.services.amusement": "Huvitukset",
  "harbor.services.shop": "Kauppa",
  "harbor.services.pharmacy": "Apteekki",
  "harbor.services.bank": "Pankki",
  "harbor.services.post_office": "Posti",
  "harbor.services.alko": "Alko",
  "harbor.services.bus": "Bussi",
  "harbor.services.ferry": "Lautta",
  "harbor.services.accommodation": "Majoitus",
  "harbor.services.guidance": "Opastus",
  "harbor.services.recycling": "Kierrätys",
  "harbor.services.otherservice": "Muu palvelu",
  "harbor.services.dentist": "Hammaslääkäri",
  "harbor.services.taxi": "Taksi",
  "harbor.services.doctor": "Lääkäri",
  "harbor.services.vet": "Eläinlääkäri",
  "harbor.services.wlan": "Wi‑Fi",
  "harbor.voting.sectionTitle": "Vuoden Vierassatamaäänestys",
  "harbor.voting.rateHarborCard": "Arvioi satama",
  "harbor.voting.rateHarbor": "Arvioi satamaa",
  "harbor.voting.rateThisHarbor": "Arvioi tämä satama:",
  "harbor.voting.leaveComment": "Jätä kommentti",
  "harbor.voting.send": "Lähetä",
  "harbor.voting.sending": "Lähetetään…",
  "harbor.voting.ratingSaved": "Arvio tallennettu!",
  "harbor.voting.rateAlso": "Arvio lisäksi:",
  "harbor.voting.category.cleanliness": "Siisteys",
  "harbor.voting.category.facilities": "Palvelut",
  "harbor.voting.category.staff": "Henkilökunta",
  "harbor.voting.category.dock": "Laituri",
  "harbor.voting.category.waste": "Jätehuolto",
  "harbor.voting.category.childrenAndYouth": "Lapset ja nuoret",
  "harbor.voting.footerBlurb": "Suomen Purjehdus ja veneily ry on järjestänyt äänestyksen vuodesta 1987. Tänä vuonnakin palkitaan sekä rannikkoalueen että Järvi-Suomen suosikit.",
  "harbor.voting.errorSave": "Arvion tallennus epäonnistui. Yritä uudelleen.",
  "harbor.voting.partnerLogos": "Kumppanit",
  "vesselSettings.title": "Aluksen asetukset",
  "vesselSettings.draft": "Syväys",
  "vesselSettings.height": "Korkeus",
  "vesselSettings.speed": "Keskinopeus",
  "vesselSettings.draftHint": "Huomioidaan väyläreitityksessä",
  "vesselSettings.heightHint": "Huomioidaan väyläreitityksessä siltojen kohdalla",
  "vesselSettings.speedHint": "Käytetään matka-ajan laskennassa",
  "vesselSettings.presetSail": "Purjevene-esiasetus",
  "vesselSettings.presetMotor": "Moottorivene-esiasetus",
  "weatherStation.defaultName": "Säähavaintoasema",
  "weatherStation.updated": "Päivitetty",
  "weatherStation.retry": "Yritä uudelleen",
  "weatherStation.error": "Sääaseman tiedot eivät latautuneet.",
  "weatherStation.wind": "Tuuli",
  "weatherStation.gust": "Puuska",
  "weatherStation.windDirection": "Tuulen suunta",
  "weatherStation.temperature": "Lämpötila",
  "weatherStation.history": "Historia",
  "weatherStation.noHistory": "Historiadataa ei ole saatavilla tälle ajanjaksolle.",
  "weatherStation.windAndGust": "Tuuli ja puuska",
  "weatherStation.dataAttribution": "Data: FMI (Ilmatieteen laitos)",
  "weatherStation.last24h": "Viimeiset 24 h",
  "weatherStation.relativeTime.justNow": "juuri nyt",
  "weatherStation.relativeTime.minutesAgo": "{{count}} min sitten",
  "weatherStation.relativeTime.hoursAgo": "{{count}} h sitten",
  "weatherStation.relativeTime.daysAgo": "{{count}} pv sitten",
  "weatherStation.units.ms": "m/s",
  "weatherStation.units.celsius": "°C",
  "weatherStation.units.degrees": "°",

  "auth.login.title": "Kirjaudu sisään",
  "auth.login.subtitle": "Lähetämme kertakoodin sähköpostiisi.",
  "auth.login.noAccount": "Ei vielä tiliä?",
  "auth.login.createAccount": "Luo tili",
  "auth.login.successTitle": "Kirjauduttu sisään",

  "auth.register.title": "Luo tili",
  "auth.register.subtitle": "Varmistamme sähköpostin ja luomme profiilin.",
  "auth.register.firstName": "Etunimi",
  "auth.register.lastName": "Sukunimi",
  "auth.register.haveAccount": "Onko sinulla jo tili?",
  "auth.register.goToLogin": "Kirjaudu sisään",
  "auth.register.successTitle": "Tili luotu",
  "auth.register.loginReady": "Voit nyt kirjautua sisään uudella käyttäjätililläsi.",
  "auth.register.privacyConsent": "Olen lukenut ja ymmärtänyt <0>tietosuojaselosteen</0>.",
  "auth.register.privacyRequired": "Tietosuojaselosteen hyväksyminen on pakollista rekisteröitymistä varten.",

  "auth.common.close": "Sulje",
  "auth.common.email": "Sähköpostiosoite",
  "auth.common.emailHelper": "Lähetämme 6-numeroisen koodin sähköpostiisi.",
  "auth.common.sendCode": "Lähetä koodi",
  "auth.common.sending": "Lähetetään…",
  "auth.common.successBody": "Voit sulkea tämän ikkunan.",

  "auth.otp.sentTitle": "Tarkista sähköpostisi",
  "auth.otp.sentBody": "Lähetimme 6-numeroisen vahvistuskoodin osoitteeseen {{email}}.",
  "auth.otp.codeLabel": "Vahvistuskoodi",
  "auth.otp.codeHelper": "Syötä 6-numeroinen koodi.",
  "auth.otp.verify": "Vahvista",
  "auth.otp.verifying": "Vahvistetaan…",
  "auth.otp.changeEmail": "Vaihda sähköposti",
  "auth.otp.noCode": "Eikö koodi tullut perille?",
  "auth.otp.resend": "Lähetä uudelleen",
  "auth.otp.resendIn": "Uudelleenlähetys {{seconds}} s",

  "account.title": "Käyttäjätili",
  "account.subtitle": "Hallinnoi profiiliasi ja asetuksia.",
  "account.back": "Takaisin kartalle",
  "account.loading": "Ladataan käyttäjätiliä…",
  "account.error": "Käyttäjätilin lataus epäonnistui.",
  "account.loginRequired": "Kirjaudu sisään nähdäksesi tilisi.",
  "account.profile.title": "Profiili",
  "account.profile.name": "Nimi",
  "account.profile.email": "Sähköposti",
  "account.profile.membership": "Jäsenyys",
  "account.profile.merikarhutMember": "Merikarhujen jäsen",
  "account.subscription.title": "Tilaukset",
  "account.subscription.premium": "Sailmate Premium",
  "account.subscription.scout": "Partiolaisten reitit",
  "account.subscription.active": "Aktiivinen",
  "account.subscription.expired": "Päättynyt",
  "account.subscription.none": "Ei tilausta",
  "account.subscription.activeUntil": "Voimassa {{date}}",
  "account.subscription.expiredOn": "Päättynyt {{date}}",
  "account.cookiePreferences": "Evästeasetukset",
  "account.delete.title": "Poista tili",
  "account.delete.description": "Poistaa tilisi ja tietosi pysyvästi. Tätä ei voi perua.",
  "account.delete.button": "Poista tili",
  "account.delete.confirmTitle": "Poistetaanko tili?",
  "account.delete.confirmBody": "Tämä poistaa tilisi ja kaikki siihen liittyvät tiedot pysyvästi. Toimintoa ei voi perua.",
  "account.delete.confirmButton": "Poista pysyvästi",
  "account.delete.inProgress": "Poistetaan…",
  "account.delete.errorMissingProfile": "Emme voineet vahvistaa tilisi tietoja. Päivitä ja yritä uudelleen.",
  "account.delete.errorMissingToken": "Istuntoa ei voitu vahvistaa. Kirjaudu sisään uudelleen.",
  "account.delete.errorGeneric": "Tilin poistaminen epäonnistui. Yritä uudelleen.",

  "consent.title": "Analytiikan suostumus",
  "consent.message": "Käytämme analytiikkaa sovelluksen parantamiseen. Voit hyväksyä tai kieltäytyä.",
  "consent.accept": "Hyväksy",
  "consent.decline": "Kieltäydy",
  "consent.preferencesTitle": "Evästeasetukset",
  "consent.currentlyAccepted": "Analytiikka on tällä hetkellä hyväksytty.",
  "consent.currentlyDeclined": "Analytiikka on tällä hetkellä kielletty.",

  "menu.subscription": "Tilaus",

  "subscription.title": "Sailmaten tilaukset",
  "subscription.subtitle": "Valitse tarpeisiisi sopiva tilaus. Premium tuo navigointiin ja reittisuunnitteluun tehokkaat työkalut ja selkeät kartat, kun taas Partiolaisten reitit tarjoaa koeteltuja oikoreittejä sekä lisätietoa satamista ja kohteista.",
  "subscription.planDetails": "Hinta sisältää ALV 25,5 %. Tilaus on voimassa 12 kuukautta ja uusiutuu automaattisesti.",
  "subscription.scoutDescription": "Partiolaisten reitit -sisältöpaketti sisältää tarkat tiedot karttoineen yli 450:stä retki- ja luonnonsatamasta ja yli 2000 mpk merkitsemättömiä veneilyreittejä kartalle piirrettyinä. Satamia ja reittejä on Turunmaan saaristossa, Ahvenanmaalla, Suomenlahdella ja Pohjanlahdella. Sisältö on tehty yhteistyössä Turun Partio-Sissit Ry:n kanssa. Partiolaisten reitit -sisältöpaketin voi ostaa sekä Free- että Premium-tasoilla.",
  "subscription.benefits.title": "Miksi Sailmate Premium?",
  "subscription.benefits.subtitle": "Avaa Sailmaten koko potentiaali tehokkailla reititystyökaluilla ja kuratoiduilla partioreiteillä.",
  "subscription.benefits.routes": "Edistynyt reititys väylien mukaan",
  "subscription.benefits.places": "Tallenna ja hallinnoi suosikkipaikkojasi",
  "subscription.benefits.scoutRoutes": "Pääsy kuratoituihin Partiolaisten reitteihin (Scout-tilauksella)",
  "subscription.actions.manage": "Hallinnoi tilausta",
  "subscription.actions.loading": "Ladataan…",
  "subscription.actions.open": "Avaa",
  "subscription.actions.buy": "Valitse Premium",
  "subscription.actions.buyScout": "Valitse Partiolaisten reitit",
  "subscription.actions.changePlan": "Muuta tai peruuta Stripe-palvelussa",
  "subscription.manageOnIos": "Hallinnoi iPhonessa/iPadissa (App Store)",
  "subscription.manageOnAndroid": "Hallinnoi Android-laitteella (Google Play)",
  "subscription.manageOnMobileHint": "Tämä tilaus on ostettu mobiilikaupan kautta. Hallinnoi tilausta mobiililaitteellasi.",
  "subscription.promotionalTitle": "Kampanjatilaus",
  "subscription.promotionalBody": "Tämä tilaus on myönnetty kampanjana eikä sitä voi hallinnoida täällä.",
  "subscription.manageUnavailable": "Tämän tilauksen hallinta ei ole saatavilla tälle ostolle.",
  "subscription.management.title": "Hallinnoi tilaustasi",
  "subscription.management.subtitle": "Stripe huolehtii maksuistasi turvallisesti. Voit päivittää laskutustietoja tai perua tilauksen milloin tahansa Stripen hallintanäkymässä.",
  "subscription.disclaimer": "Hinnat, verot ja tilausta koskevat ehdot näytetään Stripe-maksusivulla. Tilaamalla hyväksyt siellä esitetyt ehdot.",
  "subscription.loginPrompt": "Kirjaudu sisään nähdäksesi olemassa olevat tilauksesi tai aloittaaksesi uuden.",
  "subscription.header.routePlanning": "Reittisuunnitteluun",
  "subscription.hero.kicker": "Veneile sujuvammin Sailmatella",
  "subscription.hero.title": "Valitse sinulle sopiva Sailmate-tilaus vesillä liikkumiseen ja reittien suunnitteluun.",
  "subscription.hero.pointPremium": "Tehokkaat työkalut navigointiin ja suunnitteluun",
  "subscription.hero.pointScout": "Satamatiedot ja partiolaisten oikoreitit",
  "subscription.hero.pointSync": "Selkeät rasteri- ja vektorikartat navigointiin",
  "subscription.trust.secureTitle": "Turvallinen ja luotettava maksu",
  "subscription.trust.secureBody": "Maksu käsitellään turvallisesti Stripen kautta. Korttitietoja ei tallenneta Sailmateen.",
  "subscription.trust.secureProof": "Powered by Stripe",
  "subscription.trust.annualTitle": "Nopea aloittaa",
  "subscription.trust.annualBody": "Luo tili minuutissa ja jatka suoraan kassalle.",
  "subscription.trust.supportTitle": "Selkeät tilaustiedot",
  "subscription.trust.supportBody": "ALV, uusiutuminen ja laskutuksen ehdot näytetään ennen maksua.",
  "subscription.actions.continuePremium": "Jatka Premiumiin",
  "subscription.actions.continueScout": "Jatka Scoutiin",
  "subscription.actions.choosePremium": "Valitse Premium",
  "subscription.actions.chooseScout": "Valitse Partiolaisten reitit",
  "subscription.actions.chooseEstonianCharts": "Valitse Viron S57-vektorikartat",
  "subscription.restore.title": "Ostitko jo tällä tilillä?",
  "subscription.restore.body": "Jos olet tilannut aiemmin, kirjaudu sisään samalla tilillä nähdäksesi nykyiset tilauksesi.",
  "subscription.restore.cta": "Kirjaudu sisään ja jatka",
  "subscription.auth.kicker": "SUJUVA OSTOPOLKU",
  "subscription.auth.title": "Luo Sailmate-tili tai kirjaudu sisään jatkaaksesi ostoa.",
  "subscription.auth.subtitle": "Jos olet aiemmin käyttänyt Sailmatea, kirjaudu sisään samalla sähköpostiosoitteella.",
  "subscription.auth.modeRegister": "Luo tili",
  "subscription.auth.modeLogin": "Kirjaudu sisään",
  "subscription.auth.pendingTitle": "Jatka tilaukseen: {{plan}}",
  "subscription.auth.pendingBody": "Vahvista Sailmate-tilisi, niin jatkamme sinut tilauksen {{plan}} kassalle.",
  "subscription.auth.registerCta": "Luo tili ja jatka",
  "subscription.auth.loginCta": "Kirjaudu sisään ja jatka",
  "subscription.auth.verifyCta": "Vahvista ja jatka",
  "subscription.auth.emailHelper": "Lähetämme 6-numeroisen koodin sähköpostiisi.",
  "subscription.auth.otpSentBody": "Lähetimme 6-numeroisen vahvistuskoodin osoitteeseen {{email}}.",
  "subscription.auth.successTitle": "Tili on valmis. Jatketaan kassalle.",
  "subscription.auth.successBody": "Olet kirjautunut sisään. Turvallinen kassa aukeaa automaattisesti.",
  "subscription.auth.successSignedIn": "Olet nyt kirjautunut sisään.",
  "subscription.signedIn.kicker": "Tili valmis",
  "subscription.signedIn.title": "Olet kirjautunut sisään ja valmis tilaamaan.",
  "subscription.signedIn.body": "Käytä Sailmate-tiliäsi kassalle siirtymiseen, Stripe-laskutuksen hallintaan ja nykyisen tilaustilanteen tarkistamiseen.",
  "subscription.signedIn.readyChip": "Kirjautunut",
  "subscription.signedIn.email": "Kassa ja tilauksen hallinta käyttävät sähköpostia {{email}}.",
  "subscription.signedIn.switchEmail": "Kirjaudu toisella sähköpostiosoitteella",
  "subscription.redirecting.title": "Valmistellaan kassaa",
  "subscription.redirecting.body": "Tilisi on valmis. Jatkamme sinut turvalliseen kassaan.",
  "subscription.plan.featured": "Paras aktiiviseen navigointiin",
  "subscription.plan.addOn": "Mainio lisäpaketti retkien suunnitteluun",
  "subscription.plan.featuredShort": "Suosittu",
  "subscription.checkoutReady": "Kassa käyttää Sailmate-tilisi sähköpostia ja aukeaa Stripessa.",
  "subscription.errors.checkoutUnavailable": "Kassaa ei voitu vielä valmistella. Tarkista tilitietosi ja yritä uudelleen.",
  "subscription.premiumSubtitle": "Reittisuunnitteluun ja navigointiin",
  "subscription.premiumDescription": "Kokeile 3 päivää maksutta. Sailmate Premiumilla suunnittelet reitit ja saat käyttöösi merisään, satamakartat, lisäkarttakerrokset sekä AIS-havainnot. Mukana ovat myös navigointiominaisuudet, kuten sijaintinäyttö, suuntaviiva, nopeusnäyttö, etäisyysympyrä, kuljetun reitin tallennus ja offline-kartat.\n\nTilauksen veloitus alkaa 3 päivän kokeilun jälkeen. Voit perua milloin tahansa kokeilujakson aikana ilman veloitusta.",
  "subscription.premiumFeature1": "Selkeät S57-vektorikartat",
  "subscription.premiumFeature2": "Navigoi mobiilisovelluksella",
  "subscription.premiumFeature3": "Näe satamien lähestymiskartat",
  "subscription.premiumFeature4": "Synkronoi reitit ja suosikit kaikille laitteillesi",
  "subscription.scoutSubtitle": "Kuratoidut reitit ja satamatiedot retkiveneilyyn",
  "subscription.estonianChartsTitle": "Viron S57-vektorikartat",
  "subscription.estonianChartsSubtitle": "Lisäpaketti Viron vesille",
  "subscription.estonianChartsDescription": "Lisää kartalle Viron S57-vektorikartat.",
  "subscription.estonianChartsPremiumRequired": "Vaatii aktiivisen Sailmate Premium -tilauksen.",
  "subscription.scoutDescriptionShort": "Partiolaisten reitit -sisältöpaketti tuo kartalle yli 450 retki- ja luonnonsatamaa sekä yli 2000 mpk merkitsemättömiä veneilyreittejä. Sisältö kattaa Turunmaan saariston, Ahvenanmaan, Suomenlahden ja Pohjanlahden, ja se on tehty yhteistyössä Turun Partio-Sissit ry:n kanssa.\n\nSisältöpaketti on ostettavissa sekä Free- että Premium-tasoille.",
  "subscription.scoutFeature1": "Lisätiedot yli 450 retki- ja luonnonsatamasta",
  "subscription.scoutFeature2": "Yli 2 000 meripeninkulmaa reittejä",
  "subscription.scoutFeature3": "Scout-reitit ja satamatiedot kuratoituna pohjoisille vesille",
  "subscription.paymentReturn.successTitle": "Maksu onnistui",
  "subscription.paymentReturn.successBody": "Tilauksesi aktivoidaan. Se voi näkyä hetken viiveellä.",
  "subscription.paymentReturn.cancelTitle": "Maksu peruttiin",
  "subscription.paymentReturn.cancelBody": "Tilaukseesi ei tehty muutoksia. Voit yrittää uudelleen milloin tahansa.",
  "subscription.paymentReturn.unknownTitle": "Maksun päivitys",
  "subscription.paymentReturn.unknownBody": "Saimme maksupäivityksen. Tarkista tilauksesi tila alta.",
  "subscription.paymentReturn.errorTitle": "Maksu epäonnistui",
  "subscription.paymentReturn.errorBody": "Maksun käsittely epäonnistui. Yritä uudelleen tai käytä toista korttia. Jos ongelma jatkuu, ota yhteyttä tukeen.",
  "subscription.errors.misconfigured": "Stripesin asetukset puuttuvat. Ota yhteyttä tukeen.",
  "subscription.errors.portalUnavailable": "Tilausten hallinta ei ole juuri nyt käytettävissä.",

  "auth.errors.invalidForm": "Tarkista kentät ja yritä uudelleen.",
  "auth.errors.invalidCode": "Syötä kelvollinen 6-numeroinen koodi.",
  "auth.errors.emailInUse": "Sähköpostiosoite on jo käytössä. Kokeile kirjautua sisään.",
  "auth.errors.loginFailed": "Kirjautuminen epäonnistui, tarkasta osoite ja yritä uudelleen. Jos sinulla ei ole tiliä, voit rekisteröityä valitsemalla \"Luo tili\".",
  "auth.errors.otpFailed": "Koodin vahvistus epäonnistui. Yritä uudelleen.",
  "auth.errors.generic": "Jotain meni pieleen. Yritä uudelleen.",
  "errorBoundary.title": "Jotain meni pieleen",
  "errorBoundary.subtitle": "Odottamaton virhe",
  "errorBoundary.message": "Sovelluksessa tapahtui odottamaton virhe. Voit yrittää uudelleen, päivittää sivun tai palata etusivulle.",
  "errorBoundary.retry": "Yritä uudelleen",
  "errorBoundary.reload": "Päivitä sivu",
  "errorBoundary.goHome": "Etusivulle",
  "errorBoundary.details": "Virheen tiedot",
  "errorBoundary.copyError": "Kopioi virhe",
  "errorBoundary.errorMessage": "Virheilmoitus",
  "errorBoundary.componentStack": "Komponenttipino",
  "errorBoundary.helpText": "Jos ongelma jatkuu, ota yhteyttä tukeen.",
  "webglError.title": "WebGL ei ole käytettävissä",
  "webglError.subtitle": "Sovellus vaatii grafiikkakiihdytyksen käyttöä.",
  "webglError.message": "Tämä sovellus vaatii WebGL:n karttojen ja grafiikan näyttämiseen. WebGL näyttää olevan poistettu käytöstä tai ei ole saatavilla selaimessasi.",
  "webglError.howToEnable": "Miten WebGL otetaan käyttöön:",
  "webglError.step1": "Päivitä selaimesi uusimpaan versioon",
  "webglError.step2": "Tarkista selaimen asetukset ja ota laitteistokiihdytys käyttöön",
  "webglError.step3": "Jos käytät Chromea tai Edgeä: Siirry kohtaan chrome://settings/system ja ota käyttöön 'Käytä grafiikkakiihdytystä, jos se on käytettävissä'",
  "webglError.reload": "Päivitä sivu",
  "webglError.helpText": "Kun olet ottanut WebGL:n käyttöön, päivitä sivu jatkaaksesi.",

  "onboarding.title": "Pikakäynnistys",
  "onboarding.stepCount": "Vaihe {{current}} / {{total}}",
  "onboarding.progressLabel": "Käyttöönoton eteneminen",
  "onboarding.selected": "Valittu",
  "onboarding.dontShowAgain": "Älä näytä tätä enää",
  "onboarding.back": "Takaisin",
  "onboarding.finish": "Aloita purjehdus",
  "onboarding.next": "Seuraava",
  "onboarding.step1.kicker": "Tervetuloa",
  "onboarding.step1.title": "Tervetuloa uuteen Sailmateen",
  "onboarding.step1.body": "Sailmaten uusi web-sovellus tarjoaa entistä kattavampia toimintoja onnistuneiden venereissujen suunnitteluun. Uudessa sovelluksessa voit hyvinkin löytää puutteita tai virheitä - kerro niistä meille!",
  "onboarding.step1.pill1Title": "Kätevä reittisuunnittelu",
  "onboarding.step1.pill1Body": "Tee reittisuunnitelmat uudella helppokäyttöisellä web-sovelluksella ja navigoi Premium-tilauksella Sailmate-mobiilisovelluksella.",
  "onboarding.step1.pill2Title": "Yksi näkymä veneilyyn",
  "onboarding.step1.pill2Body": "Sailmate-webissä tutkit karttoja, satamia, säätilannetta ja AIS-liikennettä yhdessä näkymässä.",
  "onboarding.step2.kicker": "Merikartat",
  "onboarding.step2.title": "Valitse karttatyyli",
  "onboarding.step2.body": "Valitse aloituskarttataso. Voit vaihtaa sen milloin tahansa Karttatasot-valikosta.",
  "onboarding.step2.rasterTitle": "Rasterimerikortti",
  "onboarding.step2.rasterBody": "Viralliset paperikartat digitaalisessa muodossa.",
  "onboarding.step2.rasterFeature1": "Virallinen merikartta",
  "onboarding.step2.rasterFeature2": "Karttasarjoista tuttu esitystapa",
  "onboarding.step2.rasterFeature3": "Tärkeimmät tiedot aina näkyvissä",
  "onboarding.step2.vectorTitle": "Vektorimerikartta",
  "onboarding.step2.vectorBody": "Selkeä vektorityyli, joka pysyy terävänä zoomauksessa.",
  "onboarding.step2.vectorFeature1": "Sisältö mukautuu karttaa loitonnettaessa ja lähennettäessä",
  "onboarding.step2.vectorFeature2": "Selkeämpi esitystapa",
  "onboarding.step2.vectorFeature3": "Toistaiseksi avoimen datan kartta, virallinen vektorikartta tulossa!",
  "onboarding.step2.footer": "Vinkki: avaa Karttatasot ja vaihda rasterin ja vektorin välillä.",
  "onboarding.step3.kicker": "Tilaukset",
  "onboarding.step3.title": "Premium ja Partiolaisten reitit vievät pidemmälle",
  "onboarding.step3.body": "Paranna veneilykokemustasi Premium-tilauksella ja Partiolaisten reitit -sisältöpaketilla.",
  "onboarding.step3.premiumTitle": "Premium",
  "onboarding.step3.premiumChip": "Navigointiin",
  "onboarding.step3.premiumBody": "Premiumin avulla reittisuunnitelmat käyvät toteen.",
  "onboarding.step3.premiumFeature1": "Navigoi mobiilisovelluksella",
  "onboarding.step3.premiumFeature2": "Satamien lähestymiskartat",
  "onboarding.step3.premiumFeature3": "",
  "onboarding.step3.scoutTitle": "Partiolaisten reitit",
  "onboarding.step3.scoutChip": "Paikallistuntemus",
  "onboarding.step3.scoutBody": "Partiolaisten reitit ja satamatiedot.",
  "onboarding.step3.scoutFeature1": "Kattavat lisätiedot yli 450 retki- ja luonnonsatamasta",
  "onboarding.step3.scoutFeature2": "2000 mpk merkitsemättömiä reittejä",
  "onboarding.step3.scoutFeature3": "",
  "onboarding.step3.viewPlans": "Näytä tilaukset",
  "onboarding.step3.login": "Kirjaudu sisään",
  "onboarding.step3.loggedInHint": "Olet kirjautunut sisään. Voit hallita tilaustasi käyttäjätilistä.",
  "onboarding.close": "Sulje",
  "onboarding.footerTour": "Tutustu pikakierroksella",
  "tour.stepCount": "Vaihe {{current}} / {{total}}",
  "tour.back": "Takaisin",
  "tour.next": "Seuraava",
  "tour.done": "Valmis",
  "tour.steps.menu.title": "Päävalikko",
  "tour.steps.menu.body": "Käyttäjätili, reitit, asetukset ja tuki yhdessä paikassa.",
  "tour.steps.routeDrawer.title": "Reittisuunnitelma",
  "tour.steps.routeDrawer.body": "Katso reittisuunnitelman reittipisteet ja tallenna reitti pilveen.",
  "tour.steps.routing.title": "Reittisuunnittelun tila",
  "tour.steps.routing.body": "Valitse tilaksi tallennetun paikan lisäys, automaattinen väyläreititys tai manuaalinen reititys. Lisää paikka tai reittipiste painamalla karttaa pitkään.",
  "tour.steps.reach.title": "Saavutettava alue",
  "tour.steps.reach.body": "Näe, kuinka pitkälle pääset väyliä pikin viimeisestä reittipisteestä asettamasi etäisyys huomioiden",
  "tour.steps.search.title": "Haku",
  "tour.steps.search.body": "Hyppää paikkoihin ja satamiin nopealla haulla.",
  "tour.steps.savedPlace.title": "Lisää tallennettu paikka",
  "tour.steps.savedPlace.body": "Kun reitin muokkaus ei ole käytössä, voit lisätä tallennetun paikan painamalla karttaa pitkään.",
  "tour.steps.editRoute.title": "Muokkaa reittiä",
  "tour.steps.editRoute.body": "Reitin muokkaustilassa lisää reittipiste painamalla karttaa pitkään. Voit lisätä reittipisteen keskelle legiä vetämällä reitin uuteen sijaintiin. Kosketusnäytöllä paina reittiviivaa tai reittipistettä pitkään aloittaaksesi siirron.",
  "tour.steps.layers.title": "Karttatasot",
  "tour.steps.layers.body": "Valitse karttatyyli ja kytke sää, AIS ja muut tasot.",
  "tour.steps.controls.title": "Karttaohjaimet",
  "tour.steps.controls.body": "Lähennä ja palauta pohjoinen yhdellä kädellä.",
  "tour.steps.forecast.title": "Sääennuste",
  "tour.steps.forecast.body": "Avaa sääennuste kartalle ja selaa tuulta, puuskaa, lämpötilaa ja muita tietoja ajan mukaan. Napauta karttaa piste-ennustetta varten."
}
